define("calendar/components/calendar/settings/time-zone", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _object, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="u--row">
    <div class="u--col__4">
      <h5 class="u--text--md u--m__t__0" data-test-id="calendar-settings-timezone-title">
        {{t "calendar.settings.timezone_title"}}
      </h5>
    </div>
    <div class="u--col__8">
      <form class="o--formWrapper u--m__b__sm">
        <select class="o--form__select" {{on "change" this.setTimeZone}} >
          {{#each this.allTimeZones as |timeZone|}}
            <option value={{timeZone.name}} selected={{are-equal timeZone.name this.currentSetTimeZone}}>
              {{timeZone.name}}
            </option>
          {{/each}}
        </select>
      </form>
      <p class="u--text--light">{{t "calendar.settings.timezone_detail"}}</p>
    </div>
  </div>
  
  */
  {
    "id": "0csAnVFc",
    "block": "[[[10,0],[14,0,\"u--row\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n    \"],[10,\"h5\"],[14,0,\"u--text--md u--m__t__0\"],[14,\"data-test-id\",\"calendar-settings-timezone-title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"calendar.settings.timezone_title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n    \"],[10,\"form\"],[14,0,\"o--formWrapper u--m__b__sm\"],[12],[1,\"\\n      \"],[11,\"select\"],[24,0,\"o--form__select\"],[4,[38,1],[\"change\",[30,0,[\"setTimeZone\"]]],null],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"allTimeZones\"]]],null]],null],null,[[[1,\"          \"],[10,\"option\"],[15,2,[30,1,[\"name\"]]],[15,\"selected\",[28,[37,4],[[30,1,[\"name\"]],[30,0,[\"currentSetTimeZone\"]]],null]],[12],[1,\"\\n            \"],[1,[30,1,[\"name\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--light\"],[12],[1,[28,[35,0],[\"calendar.settings.timezone_detail\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"timeZone\"],false,[\"t\",\"on\",\"each\",\"-track-array\",\"are-equal\"]]",
    "moduleName": "calendar/components/calendar/settings/time-zone.hbs",
    "isStrictMode": false
  });

  let TimeZoneComponent = (_dec = (0, _service.inject)('config'), (_class = class TimeZoneComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "calendarConfig", _descriptor3, this);

      _initializerDefineProperty(this, "errors", _descriptor4, this);

      _initializerDefineProperty(this, "intl", _descriptor5, this);

      _initializerDefineProperty(this, "segment", _descriptor6, this);

      _initializerDefineProperty(this, "userConfig", _descriptor7, this);
    }

    get allTimeZones() {
      return this.userConfig.timezones;
    }

    get currentSetTimeZone() {
      var _this$userConfig$curr;

      return ((_this$userConfig$curr = this.userConfig.currentTimeZone) === null || _this$userConfig$curr === void 0 ? void 0 : _this$userConfig$curr.name) || this.auth.currentUserModel.timeZone;
    }

    setTimeZone(_ref2) {
      var _this$allTimeZones, _this$calendarConfig$;

      let {
        target: {
          value
        }
      } = _ref2;
      const timeZone = (_this$allTimeZones = this.allTimeZones) === null || _this$allTimeZones === void 0 ? void 0 : _this$allTimeZones.find(zone => zone.name === value);

      if (!timeZone) {
        return this.errors.log('Unable to find time zone.', {
          value,
          allTimeZones: this.allTimeZones
        });
      }

      const {
        name,
        identifier
      } = timeZone;
      this.alerts.success(this.intl.t('alerts.calendar.settings.timezone_change_success.message'), {
        title: this.intl.t('alerts.calendar.settings.timezone_change_success.title')
      });
      (0, _object.set)(this.userConfig, 'currentTimeZone', {
        name,
        identifier
      });
      (_this$calendarConfig$ = this.calendarConfig.fullCalendar) === null || _this$calendarConfig$ === void 0 ? void 0 : _this$calendarConfig$.setOption('timeZone', identifier);
      this.segment.track('changed-calendar-timezone', {
        timezone: this.currentSetTimeZone
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "calendarConfig", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setTimeZone", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setTimeZone"), _class.prototype)), _class));
  _exports.default = TimeZoneComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TimeZoneComponent);
});